import { render, staticRenderFns } from "./WxConfig.vue?vue&type=template&id=6b2e8ee1&scoped=true&"
import script from "./WxConfig.vue?vue&type=script&lang=js&"
export * from "./WxConfig.vue?vue&type=script&lang=js&"
import style0 from "./WxConfig.vue?vue&type=style&index=0&id=6b2e8ee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e8ee1",
  null
  
)

export default component.exports